import * as React from 'react';

import type {ActionBarActionEnum} from 'nutshell-graphql-types';
import type {
    ChatActionsFragment,
    GetPrimaryContextDocument_primaryContextDocument_aiSuggestions as AiSuggestionType,
} from 'nutshell-graphql-types';

import {Stack} from '../layout/stack/stack';

import {ChatActionBar} from './chat-action-bar';
import {ChatNudges} from './chat-nudges';
import {ChatToggleButton} from './chat-toggle-button';
import {NudgeInput} from './nudge-input';

type Props = {
    icon: React.ReactNode | string;
    primaryColor: string;
    secondaryColor: string;
    actionBarEnabled: boolean;
    actionBarShownActions: ActionBarActionEnum[];
    actions: ChatActionsFragment;
    appearanceCallToAction: string;
    showNudge: boolean;
    suggestions: Array<AiSuggestionType>;
    isLoadingSuggestions: boolean;
};

export function MinimizedPreview(props: Props) {
    return (
        <Stack spacing={8} alignItems='center'>
            {props.showNudge && (
                <ChatNudges
                    suggestions={props.suggestions}
                    secondaryColor={props.secondaryColor}
                    isLoading={props.isLoadingSuggestions}
                />
            )}
            {props.actionBarEnabled ? (
                <Stack spacing={8} alignItems='end'>
                    <NudgeInput
                        appearanceColor={props.primaryColor}
                        appearanceCallToAction={props.appearanceCallToAction}
                    />
                    <ChatActionBar
                        shownActions={props.actionBarShownActions}
                        actionsDetails={props.actions}
                        backgroundColor={props.primaryColor}
                        isOpen={true}
                    />
                </Stack>
            ) : (
                <ChatToggleButton
                    backgroundColor={props.primaryColor}
                    isChatOpen={false}
                    openIcon={props.icon}
                    showNudge={true}
                    appearanceCallToAction={props.appearanceCallToAction}
                />
            )}
        </Stack>
    );
}
